import React, { useRef } from "react";
import { motion, useInView } from "motion/react";

const bgUrl = (process.env.PUBLIC_URL || "") + "/img/after_party/A-238.jpg";

const luxuryEase = [0.22, 1, 0.36, 1];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.22,
      delayChildren: 0.18,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1.1, ease: luxuryEase },
  },
};

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 1.2, ease: luxuryEase },
  },
};

const buttonVariants = {
  hidden: { opacity: 0, y: 24, scale: 0.96 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 1, ease: luxuryEase, delay: 0.08 },
  },
};

const h1Style = {
  fontWeight: 700,
  fontStyle: "normal",
  fontSize: "72px",
  lineHeight: "115%",
  letterSpacing: "0.1em",
  textAlign: "center",
  color: "#fff",
};

const h3Style = {
  fontWeight: 400,
  fontSize: "36px",
  lineHeight: "110%",
  letterSpacing: "0.15em",
  textAlign: "center",
  textTransform: "uppercase",
  color: "#fff",
};

const h4Style = {
  fontWeight: 400,
  fontSize: "24px",
  lineHeight: "110%",
  letterSpacing: "0.15em",
  textAlign: "center",
  textTransform: "uppercase",
  color: "#fff",
};

export function AfterParty() {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.2 });

  return (
    <section
      ref={sectionRef}
      id="after-party"
      className="after-party-section"
      aria-label="After party"
      style={{ backgroundImage: `url(${bgUrl})` }}
    >
      <motion.div
        className="after-party-section__overlay"
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={overlayVariants}
      />
      <div className="after-party-section__content">
        <motion.div
          className="after-party-section__content-inner"
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <motion.h1 style={h1Style} variants={itemVariants}>
            THE YACHT AFTER PARTY
          </motion.h1>
          <motion.h3 style={h3Style} variants={itemVariants}>
            2,000.00 THB /day
          </motion.h3>
          <motion.h3 style={h4Style} className="after-party-section__tagline" variants={itemVariants}>
          “Get 100% vouchers on your 2,000 THB ticket 
          to spend on drinks!”
          </motion.h3>
          <motion.a
            href="https://www.theyachtparty.casheers.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="after-party-section__btn"
            variants={buttonVariants}
          >
            BOOK NOW
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
